import axios from 'axios'
import {
  eddid_idp_admin_api
} from './env'
let instance = axios.create({
  baseURL: eddid_idp_admin_api,
  headers: {}
});
// axios.defaults.withCredentials=true;
function request(options) {
  return new Promise((resolve, reject) => {
    instance(options)
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      });
  })
}

let api = {
  changePassword: (options) => { //自己的接口名称
    return request({
      method: 'put', //请求方式
      url: '/user/update',
      data: options || {}
    })
  }
}
export default api;
